import { Slider as FplSlider } from '@figma/fpl-components';
import React, { useState, useEffect } from 'react';
import { Box } from '@/UI/Box/Box';
import { LineInput } from '@/UI/Input/Input';
import {
  Row,
  SliderContainer,
  FullWidthBox, // Import the new styled component
} from './number-input-field.styled';

export const NumberInputField = ({
  inputKey,
  title,
  value,
  disabled,
  min,
  max,
  type,
  onChange,
}: NumberInputFieldProps): React.JSX.Element => {
  const [tempValue, setTempValue] = useState(`${value || 0}`);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTempValue(e.target.value); // Update temporary value
  };

  useEffect(() => {
    setTempValue(`${value || 0}`);
  }, [value]);

  const submitNewValue = () => {
    let newValue = parseFloat(tempValue);
    if (isNaN(newValue)) {
      newValue = value;
    }
    if (newValue <= min) {
      newValue = min;
    }
    if (newValue >= max) {
      newValue = max;
    }
    if (type === 'integer') {
      newValue = Math.round(newValue);
    }

    setTempValue(String(newValue));
    onChange(inputKey, newValue);
  };

  return (
    <Box>
      <Row>
        <FullWidthBox>
          {' '}
          <SliderContainer>
            <Box sx={{ width: '80%', mr: 2 }}>
              <FplSlider
                size="sm"
                value={value || 0}
                min={min}
                rangeAnchor={min}
                max={max}
                step={type === 'integer' ? 1 : 0.1}
                bigStep={type === 'integer' ? 10 : 1}
                disabled={disabled}
                aria-label={title || inputKey}
                onChange={(next) => {
                  setTempValue(String(next));
                  onChange(inputKey, next);
                }}
              />
            </Box>
            <Box sx={{ fontSize: '0.75rem' }}>
              <LineInput
                disabled={disabled}
                value={tempValue}
                size="small"
                onChange={handleInputChange}
                onBlur={submitNewValue}
                onFocus={(e) => e.target.select()}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    submitNewValue();
                  }
                }}
                inputProps={{
                  step: type === 'integer' ? 1 : 0.1,
                  min,
                  max,
                  type: 'number',
                  'aria-label': title || inputKey,
                }}
                sx={{ width: '32px' }}
              />
            </Box>
          </SliderContainer>
        </FullWidthBox>
      </Row>
    </Box>
  );
};
